<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lrcb31/tc-custom/9781788634830.jpg?1701060599226" alt="This image is the cover for the book Smokescreen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smokescreen
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling author, “a supersized action-suspense novel” about a celebrity turned amateur sleuth investigating a horseracing mystery (<i>Kirkus Reviews)</i>.</b><br/>  <br/> Dick Francis, Edgar Award–winning master of mystery and suspense, takes you into the thrilling world of horse racing.<br/>  <br/> Edward Lincoln may be an international film star who plays daring detectives on the big screen, but in reality he’s just an ordinary man.<br/><br/> Unfortunately, his ailing friend doesn’t seem to think so, and now he’s come to South Africa to investigate who’s been tampering with her racehorses. But it isn’t long before he realizes he must go face-to-face with a killer, and give the performance of his life to save his life . . .<br/><br/><b>Praise for the writing of Dick Francis:</b><br/><br/> “Dick Francis is a wonder.” —<i>Cleveland Plain Dealer</i><br/><br/> “An imaginative craftsman of high order.” –<i>The Sunday Times</i><br/><br/> “Few things are more convincing than Dick Francis at a full gallop.” —<i>Chicago Tribune</i><br/><br/> “Few match Francis for dangerous flights of fancy and pure inventive menace.” —<i>Boston Herald</i><br/><br/> “[The] master of crime fiction and equine thrills.” <i>—</i><i>Newsday</i><br/><br/> “[Francis] has the uncanny ability to turn out simply plotted yet charmingly addictive mysteries.” —<i>The </i><i>Wall Street Journal</i><br/><br/> “Francis is a genius.” <i>—</i><i>Los Angeles Times</i><br/><br/> “A rare and magical talent . . . who never writes the same story twice.” —<i>The </i><i>San Diego Union-Tribune</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dick Francis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e67ea2b